function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import classNames from 'classnames';
import helpers from './helpers';
import responsive from './responsives';
import colors from './colors';
import typography from './typography';
import spacing from './spacing';
import flexbox from './flexbox';

var compose = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (args) {
    return fns.reduce(function (arg, fn) {
      return fn(arg);
    }, args);
  };
};

export default {
  propTypes: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, helpers.propTypes), responsive.propTypes), colors.propTypes), typography.propTypes), flexbox.propTypes),
  defaultProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, helpers.defaultProps), responsive.defaultProps), colors.defaultProps), typography.defaultProps), flexbox.defaultProps),
  classnames: function classnames(props) {
    return classNames(helpers.classnames(props), responsive.classnames(props), colors.classnames(props), typography.classnames(props), spacing.classnames(props), flexbox.classnames(props));
  },
  clean: function clean(props) {
    return compose(helpers.clean, responsive.clean, colors.clean, typography.clean, spacing.clean, flexbox.clean)(props);
  }
};